import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-3 col-sm-6" }
const _hoisted_6 = { class: "form-group mb-4" }
const _hoisted_7 = { value: null }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-lg-4 col-sm-6" }
const _hoisted_10 = { class: "form-group mb-4" }
const _hoisted_11 = { value: null }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col-lg-3 col-sm-6" }
const _hoisted_14 = { class: "form-group mb-4" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-lg-3 col-sm-6" }
const _hoisted_17 = { class: "form-group mb-4" }
const _hoisted_18 = { value: null }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "col-lg-2 col-sm-6" }
const _hoisted_21 = { class: "form-group mb-4" }
const _hoisted_22 = { value: null }
const _hoisted_23 = { value: "true" }
const _hoisted_24 = { value: "false" }
const _hoisted_25 = { class: "col-lg-7 col-sm-6 text-end mt-4" }
const _hoisted_26 = { class: "d-inline-flex flex-wrap gap-3 justify-content-end" }
const _hoisted_27 = { class: "default-table-area style-two default-table-width" }
const _hoisted_28 = { class: "table-responsive" }
const _hoisted_29 = { class: "table align-middle" }
const _hoisted_30 = { class: "text-body" }
const _hoisted_31 = { class: "text-body" }
const _hoisted_32 = { class: "text-body" }
const _hoisted_33 = { class: "text-body" }
const _hoisted_34 = { class: "text-body" }
const _hoisted_35 = { class: "text-body text-center" }
const _hoisted_36 = { class: "text-body text-center" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "text-body" }
const _hoisted_39 = { class: "text-body" }
const _hoisted_40 = { class: "text-body" }
const _hoisted_41 = { class: "text-body" }
const _hoisted_42 = { class: "text-center" }
const _hoisted_43 = { class: "" }
const _hoisted_44 = { class: "p-4 pt-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayLoader = _resolveComponent("OverlayLoader")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OverlayLoader, { visible: _ctx.isLoading }, null, 8 /* PROPS */, ["visible"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "label text-secondary strong" }, "Torneo", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.tournamentId) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getMatchesByTournament()))
                  }, [
                    _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsTournament, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: i
                      }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_8))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.tournamentId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "label text-secondary strong" }, "Partido", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.matchId) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example"
                  }, [
                    _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsMatch, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: i
                      }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_12))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.matchId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label text-secondary" }, "Nombre de la Jugada", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.name) = $event)),
                    class: "form-control h-55",
                    placeholder: "Ingrese nombre"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.filters.name]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label text-secondary" }, "Estado Jugada", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.playStatusId) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example"
                  }, [
                    _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPlayStatus, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: i
                      }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_19))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.playStatusId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label text-secondary" }, "Estado Registro", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.isActive) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example"
                  }, [
                    _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                    _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.STATUS.ACTIVE), 1 /* TEXT */),
                    _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.STATUS.INACTIVE), 1 /* TEXT */)
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.isActive]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.getPlays(_ctx.currentPage)), ["prevent"])),
                    class: "btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                  }, " Buscar "),
                  _createVNode(_component_RouterLink, { to: "/play/create" }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                      }, [
                        _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                          _createElementVNode("span", null, "Agregar Jugada")
                        ])
                      ], -1 /* HOISTED */)
                    ])),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ])
          ], 32 /* NEED_HYDRATION */)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("table", _hoisted_29, [
              _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }),
                  _createElementVNode("th", { scope: "col" }, "#"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Torneo"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Partido"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Jugada"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Fecha Inicio"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Fecha Fin"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Orden"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Estado Partido"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Estado Registro"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode(" Creado"),
                    _createElementVNode("br"),
                    _createTextVNode(" por ")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Fecha "),
                    _createElementVNode("br"),
                    _createTextVNode("creación")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Modificado "),
                    _createElementVNode("br"),
                    _createTextVNode("por")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode(" Fecha "),
                    _createElementVNode("br"),
                    _createTextVNode(" modificación ")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Opciones")
                ])
              ], -1 /* HOISTED */)),
              (_ctx.items.length)
                ? (_openBlock(), _createBlock(_component_draggable, {
                    key: 0,
                    modelValue: _ctx.items,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.items) = $event)),
                    "item-key": "id",
                    tag: "tbody",
                    handle: ".drag-handle",
                    animation: 200,
                    disabled: !_ctx.enableOrder,
                    onEnd: _ctx.updateOrderItems
                  }, {
                    item: _withCtx(({ element: item, index }) => [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          class: _normalizeClass(["text-body text-right drag-handle", { 'opacity-50': !_ctx.enableOrder }])
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["material-symbols-outlined fs-16 text-primary", 
                        _ctx.enableOrder ? 'cursor-move' : 'cursor-not-allowed'
                      ])
                          }, " drag_indicator ", 2 /* CLASS */)
                        ], 2 /* CLASS */),
                        _createElementVNode("td", null, _toDisplayString(index + 1 + (_ctx.currentPage - 1) * _ctx.pageSize), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_30, _toDisplayString(item.match.tournament.name), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(item.match.name), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.name), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(item.startDateTimeString), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_33, _toDisplayString(item.endDateTimeString), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_34, _toDisplayString(item.order), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_35, _toDisplayString(item.playStatus.name), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_36, [
                          _createElementVNode("span", {
                            onClick: ($event: any) => (_ctx.confirmChangeStatus(item.id, item.isActive)),
                            class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeStatusClass(item.isActive)]),
                            role: "button"
                          }, _toDisplayString(item.isActive ? _ctx.STATUS.ACTIVE : _ctx.STATUS.INACTIVE), 11 /* TEXT, CLASS, PROPS */, _hoisted_37)
                        ]),
                        _createElementVNode("td", _hoisted_38, _toDisplayString(item.createdBy), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_39, _toDisplayString(item.createdAtDateTimeString), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_40, _toDisplayString(item.updatedBy), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_41, _toDisplayString(item.updatedAtDateTimeString), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _createVNode(_component_RouterLink, {
                              to: `/play/edit/${item.id}`
                            }, {
                              default: _withCtx(() => _cache[15] || (_cache[15] = [
                                _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " edit ", -1 /* HOISTED */)
                              ])),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                            _createVNode(_component_RouterLink, {
                              to: `/play/config/${item.id}`
                            }, {
                              default: _withCtx(() => _cache[16] || (_cache[16] = [
                                _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary ps-2" }, " settings ", -1 /* HOISTED */)
                              ])),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue", "disabled", "onEnd"]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createVNode(_component_Pagination, {
              currentPage: _ctx.currentPage,
              pageSize: _ctx.pageSize,
              totalItems: _ctx.totalItems,
              "onUpdate:page": _ctx.fetchPage
            }, null, 8 /* PROPS */, ["currentPage", "pageSize", "totalItems", "onUpdate:page"])
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}